module.exports = __webpack_public_path__ + "adf760d1209f5df90670d3d9b06793be.png";